<template>
  <b-form-group>
    <template slot="label">
      <b-icon-patch-question-fill
          v-if="isTooltipAvailable"
          variant="primary"
          @click="toggleVisibility()">
      </b-icon-patch-question-fill>
      {{ label }}
    </template>
    <b-alert
        :show="isTooltipVisible"
        variant="secondary">
      {{ translationName ? $t(translationName + '.long_instruction') : ''}}
    </b-alert>

    <b-form-input :id="'form' + translationName" v-if="inputType === 'default' || !inputType"
                  :value="showUpperCaseValue && value ? value.toUpperCase() : value"
                  @input="$emit('input', $event)"
                  :state="isValid"
                  tooltip
                  :disabled="disabled"
                  :title="translationName ? $t(translationName + '.short_instruction') : ''">
    </b-form-input>

    <b-form-select :id="'form' + translationName" v-if="inputType === 'select'"
                   :value="value"
                   @input="$emit('input', $event)"
                   :options="selectOptions.options"
                   :text-field="selectOptions.textField"
                   :value-field="selectOptions.valueField"
                   :state="isValid"
                   tooltip
                   :disabled="disabled"
                   :title="translationName ? $t(translationName + '.short_instruction') : ''">
      <b-form-select-option value="null" disabled>{{ $t('select.placeholder') }}</b-form-select-option>
    </b-form-select>
    <b-form-invalid-feedback>{{ translationName ? $t(translationName + '.error') : ''}}</b-form-invalid-feedback>
  </b-form-group>
</template>
{{value}}

<script>
export default {
  name: "CustomFormInput",
  data(){
    return{
      isTooltipVisible: false,
      isShowAlert: false,
    }
  },
  props: {
    inputType: {
      type: String
    },
    label: {
      type: String
    },
    isValid: {
      type: Boolean
    },
    translationName: {
      type: String
    },
    isTooltipAvailable: {
      type: Boolean
    },
    value: {
      type: [String, Number]
    },
    selectOptions: {
      type: Object,
      options: {
        type: Array,
      },
      textField: {
        type: String
      },
      valueField: {
        type: String
      },
    },
    disabled: {
      type: Boolean
    },
    showUpperCaseValue: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleVisibility(){
      this.isTooltipVisible = !this.isTooltipVisible;
    }
  }
}
</script>

<style scoped>

</style>
